import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-redirection-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './redirection-page.html',
  styleUrls: ['./redirection-page.scss']
})
export class RedirectionPage {
  errorMessage: string = 'Erro na comunicação com o sistema';

  constructor(private router: Router) {
    // Pega a mensagem do state
    const state = this.router.getCurrentNavigation()?.extras?.state as any;
    if (state?.message) {
      this.errorMessage = state.message;
    }
  }

  returnToPrevious(): void {
    window.history.back();
  }
}
